import {Fetcher} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {Organization, OrganizationSiteId} from '@mintdata-wsp/common/state/DataState';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';

export enum WSP_HOST
{
    LOCAL = 'lvh.me',
    DEV = 'dev.bdp42.com',
    PREPROD = 'preprod.bdp42.com',
    PROD = 'mintdata.com'
}

export class WindowLocationUtil
{
    public static isLocalTLD():boolean
    {
        return window.location.hostname.endsWith('.loc');
    }

    public static isLocal():boolean
    {
        return window.location.hostname.endsWith('.loc')
            || window.location.hostname.endsWith("lvh.me")
            || window.location.hostname.endsWith("localhost");
    }

    public static getHostname():string
    {
        return window.location.hostname;
    }

    public static getPath():string
    {
        return window.location.pathname;
    }

    public static getOrigin():string
    {
        return window.location.origin;
    }

    public static getCurrentHostSiteId():OrganizationSiteId | null
    {
        const hostnameParts = this._getHostnameParts();
        const numParts = hostnameParts.length;

        if( numParts === 3 || numParts === 4 )
            return hostnameParts[0];
        else
            return null;
    }

    public static isOnOrganizationHost(organization:Organization):boolean
    {
        const currentHostSiteId = WindowLocationUtil.getCurrentHostSiteId();

        if( !currentHostSiteId )
            return false;
        else
            return currentHostSiteId === organization.siteId;
    }

    public static getBaseURLForSSE():string
    {
        const protocol = window.location.protocol;
        return `${protocol}//${WindowLocationUtil.getWspApiHostname()}`;
    }

    public static getLocationToFullRedirectToSiteId(orgSiteId:string, relativePath:string):string
    {
        const siteId = orgSiteId;
        const hostnameParts = this._getHostnameParts();
        const numParts = hostnameParts.length;

        let newLocation = '';

        if( numParts === 3 || numParts === 4 )
            newLocation += `${siteId}.${this._getHostnameWithoutFirstPart()}${relativePath}`;
        else
            newLocation += `${siteId}.${this.getRootDomain()}${relativePath}`;

        return newLocation;
    }

    public static fullRedirectToSiteId(organization:Organization, relativePath:string):void
    {
        WindowLocationUtil.fullRedirectTo(
            WindowLocationUtil.getLocationToFullRedirectToSiteId(organization.siteId, relativePath)
        );
    }

    public static fullRedirectTo(host:string, relativePath:string = ''):void
    {
        const location = window.location;
        let newLocation = `${location.protocol}//`;

        newLocation += `${host}${relativePath}`;

        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // Note: this line forces the browser to perform a full page refresh
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        window.location.href = newLocation as any;
    }

    public static getProtocol():string
    {
        return window.location.protocol;
    }

    public static getRootDomain():string
    {
        const hostnameParts = this._getHostnameParts();
        const numParts = hostnameParts.length;

        if( numParts >= 2 )
        // return `${hostnameParts[numParts-2]}.${hostnameParts[numParts-1]}`;
            return hostnameParts.slice(1).join('.');
        else
            throw new Error(`Error: invalid hostname and TLD detected: ${window.location.href}`);
    }

    private static _getHostnameWithoutFirstPart():string
    {
        const hostnameParts = this._getHostnameParts();
        hostnameParts.shift();

        return hostnameParts.join('.');
    }

    private static _getHostnameParts():string[]
    {
        const location = window.location;
        const hostname = location.hostname;
        const hostnameParts:string[] = hostname.split('.');

        return hostnameParts;
    }

    public static getWspApiHostname():string
    {
        return ConfigUtil.apiHostname() || WindowLocationUtil.getHostname();
    }

    public static getFetcher():Fetcher
    {
        const apiProtocol = ConfigUtil.apiSecure() ? 'https' : 'http';
        const apiHostname = WindowLocationUtil.getWspApiHostname();
        const baseUrl = `${apiProtocol}://${apiHostname}`;

        return new Fetcher(baseUrl);
    }

    public static isSampleDesignPath() {
        const sampleDesignPaths = [
            'sample-design',
            'universe-design'
        ];
        return sampleDesignPaths.some(value => WindowLocationUtil.getPath().indexOf(value) !== -1);
    }

    public static setDocumentDomain():void
    {
        const host = window.location.hostname.split('.');

        document.domain = `${host[host.length - 2]}.${host[host.length - 1]}`;
    }
}
